import { Grid } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { CardItem, Loader, NoData } from ".";

const RecordingGrid = ({
  loading = false,
  recordings = [],
  onRecordingClick,
  isEditable,
  onEdit
}) => {
  const intl = useIntl();
  return (
    <Loader loading={loading}>
      <NoData
        message={intl.formatMessage({
          id: "Shared.RecordingGrid.NoRecordingData",
          defaultMessage: "There are no recordings. Please check later for new contents..."
        })}
        data={recordings}
      >
        <Grid container spacing={3}>
          {recordings.map(({ id, videoUrl, title, description }) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={id}>
              <CardItem
                videoUrl={videoUrl}
                title={title}
                description={description}
                onClick={
                  onRecordingClick && (() => onRecordingClick({ id, videoUrl, title, description }))
                }
                isEditable={isEditable}
                onEdit={e => {
                  onEdit({ id });
                  e.stopPropagation();
                }}
              />
            </Grid>
          ))}
        </Grid>
      </NoData>
    </Loader>
  );
};

export default RecordingGrid;
